import {
  Box,
  Divider,
  List,
  Link,
  ListItem,
  ListItemText,
} from "@mui/material";
import NavMenu, { NavigationConfig } from "../NavMenu";
import NavTopMenus from "../NavTopMenus";
import React, { useContext } from "react";
import { ThemeContext } from "../../root.component";

type NavigationsProps = {
  navigations: NavigationConfig[];
};

export default function NavMenus(props: NavigationsProps) {
  return (
    <Box
      flex={1}
      data-testid={"nav-menus"}
      sx={{
        overflowX: "hidden",
      }}
    >
      <NavTopMenus />

      <Divider sx={{ margin: "0 32px" }} />

      <List disablePadding sx={{ margin: "32px 0 0 40px" }}>
        {props.navigations.map((navigation) => {
          return (
            <NavMenu key={navigation.categoryId} navigation={navigation} />
          );
        })}
      </List>
      <OtherServices />
    </Box>
  );
}

function OtherServices() {
  const {
    palette: {
      secondary: { main: secondaryMain },
    },
  } = useContext(ThemeContext);

  return (
    <List
      disablePadding
      sx={{
        marginLeft: "40px",
        color: secondaryMain,
      }}
      data-testid="other-services"
    >
      <ListItem disablePadding sx={{ gap: "8px", padding: "8px 0px" }}>
        <Box
          sx={{
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <i className="ri-share-box-line ri-xl" color={secondaryMain} />
        </Box>
        <ListItemText
          sx={{ margin: 0 }}
          primaryTypographyProps={{ style: { fontWeight: 600 } }}
        >
          <Link
            href="https://central.thoughtworks.net/home/i-need-to"
            target="_blank"
            sx={{ textDecoration: "none" }}
            color={secondaryMain}
          >
            Other Services
          </Link>
        </ListItemText>
      </ListItem>
    </List>
  );
}
